import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Card, Button, Spinner, Alert, Row, Col } from 'react-bootstrap';
import SignatureCanvas from 'react-signature-canvas';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileSignature, faCheckCircle, faEraser, faFileContract } from '@fortawesome/free-solid-svg-icons';

const PublicAssinaturaPage = () => {
    const { codigo } = useParams();
    const sigPadRef = useRef(null);
    
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [contrato, setContrato] = useState(null);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        const fetchContrato = async () => {
            try {
                // Busca os detalhes do contrato usando o código gerado
                const response = await axios.get(`/api/public/contratos/${codigo}`);
                setContrato(response.data);
            } catch (err) {
                setError(err.response?.data?.message || "Código de contrato inválido ou já expirado.");
            } finally {
                setIsLoading(false);
            }
        };
        fetchContrato();
    }, [codigo]);

    const handleClear = () => sigPadRef.current.clear();

    const handleSave = async () => {
        if (sigPadRef.current.isEmpty()) {
            alert("Por favor, assine no quadro indicado antes de confirmar.");
            return;
        }

        setIsSaving(true);
        const signatureBase64 = sigPadRef.current.toDataURL('image/png');

        try {
            // Envia a assinatura para o backend processar e gerar o PDF
            await axios.post(`/api/public/contratos/${codigo}/assinar`, {
                assinatura: signatureBase64
            });
            setSuccess(true);
        } catch (err) {
            setError("Ocorreu um erro ao salvar sua assinatura. Por favor, tente novamente.");
        } finally {
            setIsSaving(false);
        }
    };

    if (isLoading) return <Container className="text-center mt-5 p-5"><Spinner animation="border" variant="primary" /><p className="mt-3">Carregando contrato...</p></Container>;
    
    if (success) {
        return (
            <Container className="mt-5 text-center p-5">
                <FontAwesomeIcon icon={faCheckCircle} size="5x" className="text-success mb-4" />
                <h2 className="fw-bold">Contrato Assinado!</h2>
                <p className="lead">Obrigado! Você já pode devolver o tablet ao atendente para finalizar o pagamento.</p>
            </Container>
        );
    }

    if (error) return <Container className="mt-5"><Alert variant="danger" className="shadow-sm">{error}</Alert></Container>;

    return (
        <Container className="py-4" style={{ maxWidth: '800px' }}>
            <Card className="shadow-lg border-0">
                <Card.Header className="bg-primary text-white text-center py-3">
                    <h4 className="mb-0"><FontAwesomeIcon icon={faFileContract} className="me-2" /> Termo de Prestação de Serviços</h4>
                </Card.Header>
                <Card.Body className="p-4">
                    <div className="contrato-content mb-4 p-4 bg-light border rounded shadow-sm text-dark" 
                         style={{ maxHeight: '450px', overflowY: 'auto', fontSize: '1.05rem', lineHeight: '1.6' }}
                         dangerouslySetInnerHTML={{ __html: contrato.texto_contrato }} />

                    <div className="signature-area">
                        <p className="text-center fw-bold mb-2 text-primary">Assine no quadro abaixo:</p>
                        <div className="border border-2 rounded-3 bg-white" style={{ borderStyle: 'dashed !important' }}>
                            <SignatureCanvas 
                                ref={sigPadRef}
                                penColor="black"
                                canvasProps={{
                                    className: 'signature-canvas',
                                    style: { width: '100%', height: '250px', cursor: 'crosshair' }
                                }}
                            />
                        </div>
                        <div className="d-flex justify-content-between mt-3">
                            <Button variant="outline-secondary" onClick={handleClear}>
                                <FontAwesomeIcon icon={faEraser} className="me-1" /> Limpar Quadro
                            </Button>
                            <Button variant="success" size="lg" className="px-4" onClick={handleSave} disabled={isSaving}>
                                {isSaving ? <Spinner size="sm" /> : "Confirmar e Assinar"}
                            </Button>
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default PublicAssinaturaPage;
